import { Component, Inject, OnInit, ViewChild, DOCUMENT } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../../../../environments/environment";
import { LogService } from "../../../../services/log.service";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import {  NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../services/authentication.service";

@Component({
    selector: "app-my-account",
    templateUrl: "./my-account.component.html",
    styleUrls: ["./my-account.component.scss"],
    standalone: false
})
export class MyAccountComponent implements OnInit {
  username: any;
  userRoll: any;
  idleState = "Not started.";
  timedOut: boolean = false;
  lastPing?: Date;

  userFullName: string;
  userRoleName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";

  constructor(
    public router: Router,
    private readonly logService: LogService,
    private readonly modalService: NgbModal,
      private readonly idle: Idle,
      private readonly authservice: AuthenticationService,
      private readonly keepalive: Keepalive,
      @Inject(DOCUMENT) private readonly _document: Document
  ) {
    let sessionTimeMinutes = environment.application.sessionTimeout;
    let idleSetIdleMinutes = sessionTimeMinutes - 1;
    let idleSetTimeoutMinutes = sessionTimeMinutes - idleSetIdleMinutes;

    idle.setIdle(idleSetIdleMinutes * 60);

    idle.setTimeout(idleSetTimeoutMinutes * 60);

    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      this.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      this.openSessionoutModal();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "You will time out in " + countdown + " seconds!";
    });

    keepalive.interval(sessionTimeMinutes * 60);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();
  }

  ngOnInit() {
    this.logService.getUserFullName().subscribe((fullName) => {
      this.userFullName = fullName;
    });
    this.logService.getUserRoleName().subscribe((roleName) => {
      this.userRoleName = roleName;
    });
  }

  @ViewChild("sessionoutPopupModal", { static: true }) sessionoutPopupModal;

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }
  logout() {
    this.idle.onIdleStart.unsubscribe();
    this.authservice.logout();
    this.modalService.dismissAll();
    this.router.navigate(["auth/login"]);
    this._document.defaultView.location.reload();
  }
  openSessionoutModal() {
    this.modalService
      .open(this.sessionoutPopupModal, {
        ariaLabelledBy: "modal-basic-title",
        size: "md",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }

  stay() {
    this.modalService.dismissAll();
    this.reset();
  }
}
